<template>
  <div class="frame-wrapper marker-list">
    <div class="sticky-message" v-if="stickyMessage">
      {{ stickyMessage }}
    </div>
    <div class="tool-box-container">
      <div class="tool-box">
        <div class="search-box">
          <div class="search-bar">
            <input
              v-model="searchCond"
              type="text"
              placeholder="住所または郵便番号"
            />
            <span
              class="btn btn-submit btn-search"
              :class="{ disable: !searchCond }"
              @click="search"
              ><div></div
            ></span>
          </div>
          <div
            class="search-results"
            v-if="candidates && candidates.length > 1"
          >
            <ul>
              <li
                v-for="candidate in candidates"
                :key="candidate"
                @click="onSelectAddress(candidate)"
              >
                {{ candidate.addr }}
              </li>
            </ul>
          </div>
        </div>
        <!-- <div class="tool-buttons">
          <div class="button">
            <span class="marker"></span>
          </div>
        </div> -->
      </div>
    </div>
    <div v-if="markerDragged" class="centered-box-on-map save-marker-buttons">
      <div class="centered-item">
        <div id="button-area">
          <span class="btn btn-submit" @click="saveHomeMarker"
            >地図の中心を設定</span
          >
          <span class="btn" @click="undoHomeMarker">キャンセル</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import GoogleMaps from "@/mixins/googlemaps.js";
import Loader from "@/mixins/loader";

export default {
  mixins: [GoogleMaps, Loader],

  data() {
    return {
      stickyMessage: "",
      searchCond: null,
      candidates: null,
      lat: null,
      lng: null,
      originalPos: {
        lat: null,
        lng: null,
      },
      zoomedToEdit: false,
      homeMarker: null,
      markerDragged: false,
      listenerNames: {
        clickMap: null,
        zoomChanged: null,
        dragend: null,
      },
    };
  },

  async mounted() {
    // マーカー位置を決めやすいようcursorを変更する
    this.map.setOptions({ draggableCursor: "pointer" });
    this.$emit("showMap");

    this.homeMarker = this.getHomeMarker();
    if (this.homeMarker) {
      // HOMEマーカー設定済みの場合はマーカーをdraggableに
      this.lat = this.homeMarker.getPosition().lat();
      this.lng = this.homeMarker.getPosition().lng();

      // 緯度経度を内部的に複製保持
      this.preservePosition();

      this.homeMarker.setDraggable(true);
      // ドラッグ終了イベントリスナ
      this.listenerNames.dragend = this.homeMarker.addListener(
        "dragend",
        this.dragMarker
      );
    } else {
      // 地図クリックでマーカーを設置できるようにする
      this.listenerNames.clickMap = this.map.addListener(
        "click",
        this.addHomeMarker
      );
    }

    // 地図のズームレベル変更イベントハンドラ
    this.listenerNames.zoomChanged = this.map.addListener(
      "zoom_changed",
      this.allowAddMarker
    );
    // 位置登録許可判定
    this.allowAddMarker();
  },

  destroyed() {
    // カーソルをデフォルトに戻しておく
    this.map.setOptions({ draggableCursor: undefined });

    // リスナー削除
    if (this.listenerNames.clickMap) {
      this.google.maps.event.removeListener(this.listenerNames.clickMap);
    }
    if (this.listenerNames.zoomChanged) {
      this.google.maps.event.removeListener(this.listenerNames.zoomChanged);
    }
    if (this.listenerNames.dragend) {
      this.google.maps.event.removeListener(this.listenerNames.dragend);
    }

    // ドラッグ中マーカーをもとに戻す
    if (this.markerDragged) {
      this.undoHomeMarker();
    }

    // ドラッグ禁止
    if (this.homeMarker) {
      this.homeMarker.setDraggable(false);
    }
  },

  methods: {
    ...mapActions([
      "setMapMode",
      "insertPaddyFields",
      "retrievePaddyFields",
      "showAccountID",
      "showAccount",
      "updateAccountPosition",
      "setHomeMarker",
      "initializeWeatherInfos",
      "updateAreaName",
    ]),
    ...mapGetters(["getPaddyFields", "getAccountID", "getHomeMarker"]),

    async addHomeMarker(e) {
      // 地図が十分ズームされていない場合、マーカー追加を無効にしておく
      if (!this.zoomedToEdit) {
        return;
      }

      this.lat = e.latLng.lat();
      this.lng = e.latLng.lng();

      // HOMEの位置を保存
      await this.saveHome();

      // マーカーを描画
      this.putHomeMarker(e.latLng);

      // HOMEマーカーを追加したらそれ以上追加できないようにする
      if (this.listenerNames.clickMap) {
        this.google.maps.event.removeListener(this.listenerNames.clickMap);
      }

      // 位置登録許可判定
      this.allowAddMarker();
    },

    putHomeMarker(latLng) {
      // HOMEマーカー追加
      const { Marker } = this.google.maps;
      this.homeMarker = new Marker({
        position: latLng,
        map: this.map,
        icon: {
          url: require("@/assets/icons/ic_home.png"),
          scaledSize: { width: 42, height: 56 },
        },
        draggable: true,
      });

      this.setHomeMarker(this.homeMarker);

      // ドラッグ終了イベントリスナ
      this.listenerNames.dragend = this.homeMarker.addListener(
        "dragend",
        this.dragMarker
      );
    },

    dragMarker(e) {
      this.lat = e.latLng.lat();
      this.lng = e.latLng.lng();
      this.markerDragged = true;
    },

    async saveHomeMarker() {
      await this.saveHome();
      this.markerDragged = false;
    },

    undoHomeMarker() {
      // マーカーをもとに戻す
      this.lat = this.originalPos.lat;
      this.lng = this.originalPos.lng;
      this.homeMarker.setPosition(
        new this.google.maps.LatLng(this.lat, this.lng)
      );

      this.markerDragged = false;
    },

    async saveHome() {
      await this.loading(async () => {

        const retPosition = await this.updateAccountPosition({
          id: this.getAccountID(),
          lat: this.lat,
          lng: this.lng,
        });
        this.updateAreaName(retPosition.area_name);

        // 緯度経度を内部的に複製保持
        this.preservePosition();

        // 天気のデータ更新する
        await this.initializeWeatherInfos();
      });

      // 成功通知
      this.$toasted.success("ホーム位置を保存しました。", {
        position: "top-center",
        duration: 3000,
      });
    },

    preservePosition() {
      this.originalPos.lat = this.lat;
      this.originalPos.lng = this.lng;
    },

    search() {
      var place = this.searchCond;
      var geocoder = new this.google.maps.Geocoder(); // geocoderのコンストラクタ

      geocoder.geocode(
        {
          address: place,
          region: "jp",
        },
        (results, status) => {
          if (status == this.google.maps.GeocoderStatus.OK) {
            if (results && results.length > 0) {
              this.candidates = [];
              for (let i in results) {
                this.candidates.push({
                  addr: results[i].formatted_address,
                  latlng: results[i].geometry.location,
                });
              }
              if (results.length === 1) {
                // 検索結果地が含まれるように範囲を拡大
                var bounds = new this.google.maps.LatLngBounds();
                bounds.extend(this.candidates[0].latlng);
                this.map.fitBounds(bounds, 100);
              }
            } else {
              this.candidates = null;
            }
          } else if (status == this.google.maps.GeocoderStatus.ZERO_RESULTS) {
            // FIXME
            alert("見つかりません");
          } else {
            // FIXME
            console.log(status);
            alert("エラー発生");
          }
        }
      );
    },

    onSelectAddress(candidate) {
      // 検索結果地が含まれるように範囲を拡大
      var bounds = new this.google.maps.LatLngBounds();
      bounds.extend(candidate.latlng);
      this.map.fitBounds(bounds, 200);
    },

    allowAddMarker() {
      if (this.map.getZoom() < 17) {
        // ホーム位置変更不可
        this.zoomedToEdit = false;

        this.stickyMessage =
          "地図の中心を設定するには地図をズームしてください。";

        // ドラッグ不可
        if (this.homeMarker) {
          this.homeMarker.setDraggable(false);
        }
      } else {
        // ホーム位置変更可
        this.zoomedToEdit = true;

        if (this.homeMarker) {
          this.homeMarker.setDraggable(true);
          this.stickyMessage =
            "マーカーをドラッグして地図の中心を変更することができます。";
        } else {
          this.stickyMessage =
            "地図上をクリックして地図の中心を設定してください。";
        }
      }
    },
  },
};
</script>

<style lang="scss">
.marker-list {
  &.frame-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  .tool-box-container {
    width: 400px;
    position: absolute;
    top: 30px;
    left: 30px;
    transition: height 0.5s;

    .tool-box {
      //   min-height: 100px;
      padding: 20px;
      background: white;
      box-sizing: border-box;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
      transition: height 0.5s;

      .search-bar {
        display: flex;
        align-items: center;
        height: 40px;

        input {
          border-radius: 20px 0 0 20px;

          + .btn-submit {
            width: 40px;
            height: 40px;
            border-radius: 0 20px 20px 0;

            &.btn-search > div {
              position: relative;
              left: -13px;
              width: 24px;
              height: 24px;
              background: url("~@/assets/icons/ic_search.svg") no-repeat center
                center;
            }
          }
        }
      }

      .search-results {
        position: absolute;
        background: white;
        border-radius: 0.5rem;
        border: solid 1px grey;

        ul {
          width: 360px;
          list-style: none;
          margin-block: 1rem;
          margin: 1rem 0;
          padding-inline-start: 1rem;

          li {
            margin: 0.25rem;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }

  .sticky-message {
    position: absolute;
    top: 0;
    width: 100%;
    background-color: var(--purple);
    color: white;
    text-align: center;
  }

  .btn {
    display: block;
    background: white;
    font-size: 14px;
    text-align: center;
    width: 130px;
    height: 30px;
    border-radius: 15px;
    color: var(--purple);
    padding: 6px 20px;
    margin: 10px auto 10px;
    cursor: pointer;
    &.disable {
      opacity: 0.5;
      cursor: inherit;
      pointer-events: none;
    }
    &:nth-of-type(n + 2) {
      margin-left: 1rem;
    }
    &.btn-submit {
      background: var(--purple);
      color: #fff;
    }
  }

  .top-frame-container {
    width: 100%;
    max-width: 510px;
    //   padding: 30px;
    position: absolute;
    top: 30px;
    left: 30px;
    transition: height 0.5s;

    .top-frame {
      // width: 100%;
      // max-width: 480px;
      // min-width: 350px;
      min-height: 100px;
      padding: 20px;
      // margin-right: $side-frame-width;
      background: white;
      box-sizing: border-box;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
      transition: height 0.5s;
    }

    .top-frame .title-area {
      border-bottom: none;
      display: grid;
      grid-template-columns: 1fr 200px;
      align-items: center;
      margin: 0;
      padding: 0;

      h3 {
        background: url("~@/assets/icons/ic_flag.svg") no-repeat left center;
        background-size: 30px 30px;
      }
    }
    .top-frame h3 {
      padding: 0 0 0 2em;
      margin: 0px 15px 15px 15px;
    }
    .top-frame .selectCal {
      text-align: right;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      user-select: none;
    }

    .top-frame .selectCal:active {
      opacity: 0.5;
      /* transition: 0.5s; */
    }

    .arrow-left {
      display: block;
      width: 16px;
      height: 16px;
      background: url("~@/assets/icons/ic_arrow.svg") no-repeat center center;
      background-size: 16px 16px;
      margin: 0 10px 0 0;
      cursor: pointer;
    }

    .arrow-left:active {
      transform: scale(1.2);
    }

    .arrow-right {
      display: block;
      width: 16px;
      height: 16px;
      background: url("~@/assets/icons/ic_arrow.svg") no-repeat center center;
      background-size: 16px 16px;
      transform: rotate(180deg);
      margin: 0 0 0 10px;
      cursor: pointer;
    }

    .arrow-right:active {
      transform: scale(1.2);
    }

    .top-frame .filter {
      text-align: right;
      display: block;
      cursor: pointer;
      font-size: 14px;
      margin: 0 20px 0 0;
      padding: 0;
      text-decoration: none;
      color: var(--purple);
    }

    .top-frame .filter::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_sort.svg") no-repeat center center;
      background-size: 20px 20px;
      padding: 0 0 0 20px;
    }

    .top-frame .filter:active {
      opacity: 0.5;
    }

    input[type="radio"] {
      display: none;
    }

    .input-frame-wrap {
      max-height: 500px;
      display: block;
      overflow: hidden;
      transition: ease-in-out 0.3s;
    }

    .input-frame {
      display: grid;
      grid-template-columns: repeat(auto-fill, 120px);
      justify-content: center;
      grid-row-gap: 10px;
      grid-column-gap: 10px;
      user-select: none;
      margin: 15px 0 0 0;
    }
    .input-frame-wrap.close {
      max-height: 0px;
      transition: ease-in-out 0.3s;
    }

    .input-frame-B {
      display: grid;
      justify-content: center;
      grid-template-columns: repeat(auto-fill, 120px);
      grid-row-gap: 10px;
      grid-column-gap: 10px;
      user-select: none;
      background: #eee;
      padding: 20px;
      margin: 20px 0 0 0;
      border-radius: 20px;
      border: solid 1px #ccc;
    }

    .label {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    input[type="radio"]:checked + .col1 {
      background: var(--col1);
      color: #fff;
    }

    input[type="radio"]:checked + .col2 {
      background: var(--col2);
      color: #fff;
    }
    input[type="radio"]:checked + .col3 {
      background: var(--col3);
      color: #fff;
    }
    input[type="radio"]:checked + .col4 {
      background: var(--col4);
      color: #fff;
    }
    .item-summary {
      display: flex;
      justify-content: space-around;
    }
    .select-button {
      display: block;
      width: 200px;
      margin: 20px auto 0px;
      text-align: center;
      font-size: 14px;
      padding: 10px 20px;
      border-radius: 20px;
      background: var(--purple);
      color: #fff;
      cursor: pointer;
      user-select: none;
      &#selectFlagButton::before {
        white-space: pre;
        content: "    ";
        margin: 0 10px 0 0;
        background: url("~@/assets/icons/ic_expand.svg") no-repeat center center;
      }
      &:active {
        opacity: 0.5;
      }
      &#selectItemButton {
        margin: 0;
        width: 170px;
      }
    }
    .navigate-button {
      display: block;
      //   width: 200px;
      margin: 0px auto 0px;
      text-align: center;
      font-size: 14px;
      padding: 10px 20px 0px 20px;
      border-radius: 20px;
      background: transparent;
      color: #000;
      cursor: default;
      user-select: none;
      //   &::before {
      //     white-space: pre;
      //     content: "    ";
      //     margin: 0 10px 0 0;
      //     background: url("~@/assets/icons/ic-expand-more.svg") no-repeat center
      //       center;
      //   }
    }

    .selection-frame {
      display: grid;
      grid-template-columns: 120px 120px;
      grid-column-gap: 10px;
      user-select: none;
      margin: 7px 0 7px 0;
    }
  }

  #button-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;

    .btn {
      width: 170px;
    }
  }

  .centered-box-on-map {
    position: fixed;
    left: calc(50% + (250px / 2));
    z-index: 1;

    .centered-item {
      position: relative;
      left: -50%;
    }

    &.save-marker-buttons {
      bottom: 0;
      margin-bottom: 1rem;
    }
  }

  /* フォーム */

  input[type="text"],
  input[type="date"],
  input[type="number"] {
    width: 100%;
    height: 40px;
    border-radius: 20px;
    border: solid 1px var(--purple);
    padding: 0 16px;
    font-size: 16px;
    outline: none;
  }

  input[type="text"]:focus,
  input[type="date"]:focus,
  input[type="number"]:focus {
    background: var(--purple-tertiary);
  }

  select {
    height: 40px;
    border-radius: 20px;
    border: solid 1px var(--purple);
    padding: 0 38px 0 16px;
    font-size: 16px;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
      calc(100% - 10px) center;
    background-size: 25px 25px;
  }

  select:focus {
    background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
      calc(100% - 10px) center var(--purple-tertiary);
    background-size: 25px 25px;
  }

  textarea {
    font-size: 16px;
    width: 100%;
    min-height: 200px;
    white-space: pre-wrap;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: solid 1px var(--purple);
    padding: 10px;
    border-radius: 10px 10px 0 10px;
  }

  textarea:focus {
    background: var(--purple-tertiary);
  }

  input[type="radio"] {
    display: none;
  }
  input[type="radio"] + label {
    padding: 0 20px 0 0;
  }
  input[type="radio"]:disabled + label {
    color: #aaa;
  }

  input[type="radio"] + label:before {
    display: inline-block;
    white-space: pre;
    content: "    ";
    background: url("~@/assets/icons/ic_radio_off.svg") no-repeat center left;
    background-size: 24px 24px;
    padding: 0 16px 0 0;
  }
  input[type="radio"]:checked + label:before {
    white-space: pre;
    content: "    ";
    background: url("~@/assets/icons/ic_radio_on.svg") no-repeat center left;
    background-size: 24px 24px;
    display: inline-block;
  }
  input[type="radio"]:disabled + label:before {
    white-space: pre;
    content: "    ";
    background: url("~@/assets/icons/ic_radio_disabled.svg") no-repeat center
      left;
    background-size: 24px 24px;
    display: inline-block;
  }

  input[type="checkbox"] {
    display: none;
  }
  input[type="checkbox"] + label {
    padding: 0 20px 0 0;
  }

  input[type="checkbox"] + label:before {
    display: inline-block;
    white-space: pre;
    content: "    ";
    background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat center left;
    background-size: 24px 24px;
    padding: 0 16px 0 0;
  }
  input[type="checkbox"]:checked + label:before {
    white-space: pre;
    content: "    ";
    background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center left;
    background-size: 24px 24px;
    display: inline-block;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
}
</style>
